import React, {useEffect, useState} from 'react';
import {ReturnTextAndImg} from "../CheckImg";
import CustomInput from "../components/CustomInput";

const NumbersAnswer = ({changeWriteAnswer, data, isPassed}) => {
    const dataFields = [...data]
    const props = dataFields.pop()
    const [text,setText]=useState('')
    const [answers,setAnswers]=useState([])
    const [isUserInput, setIsUserInput] = useState(false);
    const styles = {
        right: {
            border: '3px solid rgba(128, 253, 195, 0.76)',
        },
        wrongUser: {
            border: '3px solid rgba(253, 128, 128, 0.76)',
        },
    }
    function handlerText(e){
        setText(e.target.value)
        if(!isUserInput) {
            setIsUserInput(true)
        }
    }
    function changeAnswer(value, type, e) {
        if(!isPassed) {
            if (type === 1) {
                setAnswers([value])
            }
            if(type===2){
                if(e.target.checked){
                    setAnswers(prev=>[...prev,value])
                }
                else{
                    const arr = [...answers];
                    setAnswers(arr.filter(item=>item!==value))
                }
            }
            if(!isUserInput) {
                setIsUserInput(true)
            }
        }
    }

    const fields = dataFields?.map((item, i) => {
        let text = ReturnTextAndImg(item.name);
        const isChecked = answers.includes(item.name);
        const itemStyles = isPassed
            ? answers.includes(item.name)
                ? (item.percent>0?styles.right:styles.wrongUser)
                : (item.percent>0?styles.right:{})
            : {};

        if (props.type === 1) {
            return <div style={{display: 'flex', alignItems: 'center',...itemStyles}} key={i} onClick={e => {changeAnswer(item.name, props.type)}}>
                <input type="radio" readOnly checked={isChecked} disabled={isPassed}/>{text}
            </div>
        } else if (props.type === 2) {
            return <div  style={{ display: 'flex', alignItems: 'center',...itemStyles }} key={i} onClick={e => {changeAnswer(item.name, props.type, e)}}>
                <input type="checkbox"  disabled={isPassed}/>{text}
            </div>
        }
    })
    useEffect(()=>{
        if(isUserInput) {
            changeWriteAnswer({answers: answers, text: text})
        }
    },[answers,text,isUserInput])
    return (
        <div>
            <div>{fields}</div>
            <div>
                <h4>Ответ:</h4>
                <CustomInput type={'text'} style={isPassed?(props.text ===text?styles.right:styles.wrongUser):null} onChange={e=>handlerText(e)} value={text} disabled={isPassed}/>
            </div>
        </div>
    );
};

export default NumbersAnswer;